import BackendService from './BackendService';

async function getEstimate(id) {
    return BackendService.getData(`/estimates/${id}/`);
}

async function getEstimates(params) {
    return BackendService.getData('/estimates/', {}, params);
}

async function createEstimate(data = {}) {
    return BackendService.postData('/estimates/', data);
}

async function updateEstimate(id, data = {}) {
    return BackendService.patch(`/estimates/${id}/`, data);
}

async function getHighestEstimateNumber(prefix = '') {
    return BackendService.getData(`/estimates/highest-estimate-no/?prefix=${prefix}`);
}

async function getEstimateSummaryReport(data = {}) {
    return BackendService.postData('/reports/estimate-summary/', data);
}

const EstimateService = {
    getEstimate,
    getEstimates,
    createEstimate,
    updateEstimate,
    getHighestEstimateNumber,
    getEstimateSummaryReport,
};

export default EstimateService;
